import { createMutationHook } from '~/shared/providers/api';

export interface CoreUserCreateMutationParams {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber?: string | null;
  timezone: string;
  roleAssignments?: Array<{ roleId: string; facilityId: string }>;
}

export interface CoreUserCreateMutationResult {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
}

export const useCoreUserCreateMutation = createMutationHook(
  'settings.teamPermissions.coreUserCreate',
  (params: CoreUserCreateMutationParams) => ({
    coreUserCreate: {
      __args: {
        input: {
          firstName: params.firstName,
          lastName: params.lastName,
          email: params.email,
          phoneNumber: params.phoneNumber,
          timezone: params.timezone,
          roleAssignments: params.roleAssignments,
        },
      },
      id: true,
      firstName: true,
      lastName: true,
      email: true,
    },
  }),
);
